module.exports = __webpack_public_path__ + "media/images/web/home/index/specs/networking-62e6529c2e995e59381cc02a1a4cdaee.svg";